//登录
export const BOSS_LOGIN='BOSS_LOGIN';  //登录
//主页
export const GET_ORDERGOODS='GET_ORDERGOODS';  //订单状态跳转 订货
export const GET_RETURNBILL='GET_RETURNBILL';  //订单状态跳转 退货
export const GET_SWAPORDER='GET_SWAPORDER';  //订单状态跳转 换货
//报表
export const GET_PERFORMANCEDATE='GET_PERFORMANCEDATE';  //业绩统计 日期



// WEBPACK FOOTER //
// ./src/vuex/type.js